var render = function render(){var _vm=this,_c=_vm._self._c;return _c('preview-modal',{attrs:{"product":_vm.product,"is-gray-scale-on":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }